import { render } from "./ModalWindow.vue?vue&type=template&id=485cd2aa&scoped=true"
import script from "./ModalWindow.vue?vue&type=script&lang=js"
export * from "./ModalWindow.vue?vue&type=script&lang=js"

import "./ModalWindow.vue?vue&type=style&index=0&id=485cd2aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485cd2aa"]])

export default __exports__